// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BootcampUrgencyTagBootcampCohortFragment = {
  __typename?: 'BootcampCohort';
  id: string;
  startAt: number;
  totalAttendees: number;
  bootcamp: {
    __typename?: 'Bootcamp';
    id: string;
    maximumAttendees?: number | null;
  };
};

export type BootcampUrgencyTagGetCohortQueryVariables = Types.Exact<{
  cohortUrn: Types.Scalars['BootcampCohortUrn']['input'];
}>;

export type BootcampUrgencyTagGetCohortQuery = {
  __typename?: 'Query';
  bootcampCohort: {
    __typename?: 'BootcampCohort';
    id: string;
    startAt: number;
    totalAttendees: number;
    bootcamp: {
      __typename?: 'Bootcamp';
      id: string;
      maximumAttendees?: number | null;
    };
  };
};

export const BootcampUrgencyTagBootcampCohortFragmentDoc = gql`
  fragment BootcampUrgencyTag_BootcampCohort on BootcampCohort {
    id
    startAt
    totalAttendees
    bootcamp {
      id
      maximumAttendees
    }
  }
`;
export const BootcampUrgencyTagGetCohortDocument = gql`
  query BootcampUrgencyTag_GetCohort($cohortUrn: BootcampCohortUrn!) {
    bootcampCohort(id: $cohortUrn) {
      ...BootcampUrgencyTag_BootcampCohort
    }
  }
  ${BootcampUrgencyTagBootcampCohortFragmentDoc}
`;

/**
 * __useBootcampUrgencyTagGetCohortQuery__
 *
 * To run a query within a React component, call `useBootcampUrgencyTagGetCohortQuery` and pass it any options that fit your needs.
 * When your component renders, `useBootcampUrgencyTagGetCohortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBootcampUrgencyTagGetCohortQuery({
 *   variables: {
 *      cohortUrn: // value for 'cohortUrn'
 *   },
 * });
 */
export function useBootcampUrgencyTagGetCohortQuery(
  baseOptions: Apollo.QueryHookOptions<
    BootcampUrgencyTagGetCohortQuery,
    BootcampUrgencyTagGetCohortQueryVariables
  > &
    (
      | { variables: BootcampUrgencyTagGetCohortQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BootcampUrgencyTagGetCohortQuery,
    BootcampUrgencyTagGetCohortQueryVariables
  >(BootcampUrgencyTagGetCohortDocument, options);
}
export function useBootcampUrgencyTagGetCohortLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BootcampUrgencyTagGetCohortQuery,
    BootcampUrgencyTagGetCohortQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BootcampUrgencyTagGetCohortQuery,
    BootcampUrgencyTagGetCohortQueryVariables
  >(BootcampUrgencyTagGetCohortDocument, options);
}
export function useBootcampUrgencyTagGetCohortSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BootcampUrgencyTagGetCohortQuery,
        BootcampUrgencyTagGetCohortQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BootcampUrgencyTagGetCohortQuery,
    BootcampUrgencyTagGetCohortQueryVariables
  >(BootcampUrgencyTagGetCohortDocument, options);
}
export type BootcampUrgencyTagGetCohortQueryHookResult = ReturnType<
  typeof useBootcampUrgencyTagGetCohortQuery
>;
export type BootcampUrgencyTagGetCohortLazyQueryHookResult = ReturnType<
  typeof useBootcampUrgencyTagGetCohortLazyQuery
>;
export type BootcampUrgencyTagGetCohortSuspenseQueryHookResult = ReturnType<
  typeof useBootcampUrgencyTagGetCohortSuspenseQuery
>;
export type BootcampUrgencyTagGetCohortQueryResult = Apollo.QueryResult<
  BootcampUrgencyTagGetCohortQuery,
  BootcampUrgencyTagGetCohortQueryVariables
>;
